import { render, staticRenderFns } from "./NoOfferBell.vue?vue&type=template&id=0ff5fe7b&scoped=true"
import script from "./NoOfferBell.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoOfferBell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoOfferBell.vue?vue&type=style&index=0&id=0ff5fe7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5fe7b",
  null
  
)

export default component.exports